import { useStore } from '@nanostores/react';
import { useEffect, useState } from 'react';
import { CustomSelect } from '~/components/ui/CustomSelect';
import { teamStore } from '~/lib/stores/team';
import {
  allOrganizationUserRoles,
  type OrganizationUserRoles,
  type OrganizationData,
  type OrganizationMembership,
} from '~/types/organization';

export const RoleCell = ({
  organization,
  isReadonlyView,
  isSelf,
  member,
  refetchMembers,
}: {
  member: OrganizationMembership;
  organization: OrganizationData;
  isReadonlyView: boolean;
  refetchMembers: VoidFunction;
  isSelf: boolean;
}) => {
  const createTeamData = useStore(teamStore.createTeamData);
  const [memberRole, setMemberRole] = useState<OrganizationUserRoles>(member.role);

  useEffect(() => {
    setMemberRole(member.role);
  }, [member]);

  const handleRoleChange = async (newRole: OrganizationUserRoles) => {
    setMemberRole(newRole);
    await teamStore.changeRoles([member.user.username], organization, { newRole, isSingleUpdate: true });

    if (!createTeamData) {
      refetchMembers();
    }
  };

  if (!isReadonlyView && !isSelf) {
    const otherRoles = allOrganizationUserRoles.filter((role) => role !== memberRole);
    return (
      <span className="flex justify-end">
        <CustomSelect
          itemClassName="capitalize"
          triggerClassName="text-nowrap flex justify-center pr-0"
          triggerNode={memberRole.replaceAll('_', ' ')}
          items={otherRoles.map((role) => ({ label: role.replaceAll('_', ' '), value: role }))}
          onSelect={handleRoleChange}
        />
      </span>
    );
  }

  return (
    <p className="flex justify-end text-bolt-ds-textSecondary px-0">
      <span className="capitalize">{memberRole}</span>
      {isSelf && <span>&nbsp;(you)</span>}
    </p>
  );
};
